// extracted by mini-css-extract-plugin
export default {"base":"base___AG44e","heading":"heading___uNPbR","tablist":"tablist___tTVYC"};